export const TIME_SLOT = {
  BEFORE_9: 'Before 9:00 (Mon-Sat)',
  BETWEEN_9_AND_12: '9:00 - 12:00 (Mon-Sat)',
  BETWEEN_11_AND_14: '11:00 - 14:00 (Mon-Fri)',
  BETWEEN_17_AND_20: '17:00 - 20:00 (Mon-Fri)',
};

export const ACCOUNT_METADATA = {
  dob: 'user.dob',
  newsletterConsent: 'user.newsletterConsent',
  boutiqueCommunicationOptin: 'user.btqOptIn',
  personalTitle: 'user.personalTitle',
  phone: 'user.phone',
  phonePrefix: 'user.phonePrefix',
  language: 'user.language',
  country: 'user.country',
  addressSaved: 'saved',
  accountSource: 'Online_Account_source__c',
  first_name_kanji: 'user.first_name_kanji',
  last_name_kanji: 'user.last_name_kanji',
  first_name_romaji: 'user.first_name_romaji',
  last_name_romaji: 'user.last_name_romaji',
  first_name_katakana: 'user.first_name_katakana',
  last_name_katakana: 'user.last_name_katakana',
  houseMansionName: 'address.house_mansion',
  apartmentNumber: 'address.apartment_number',
  vatNumber: 'address.vatNumber',
  abn: 'address.abn',
  isClubMember: 'user.is_club_member',
  isAffiliated: 'user.is_affiliated',
  salesForceId: 'user.salesforce_id',
};

export const ACCOUNT_METADATA_VALUE = {
  addressSaved: 'TRUE',
};

export const ORDER_FLOW_METADATA = {
  wasUserAuthenticated: 'orderFlow.wasUserAuthenticated',
  wasRegisterMyWatchChecked: 'orderFlow.wasRegisterMyWatchChecked',
  wasAccountCreated: 'orderFlow.wasAccountCreated',
  createMyAccountWithoutWatch:
    'orderFlow.wasCreateMyAccountWithoutWatchChecked',
  userJoinClub: 'orderFlow.userJoinClub',
  receiveReceipt: 'orderFlow.japanReceipt',
  userAffiliated: 'orderFlow.userAffiliated',
};

export const SALEOR_PRODUCT_VARIANT_METADATA = {
  preOrderConfig: 'product_variant.pre_order_config_v2',
};

export const ONLINE_ACCOUNT_SOURCE = {
  STOREFRONT: 'storefront',
  STOREFRONT_CHECKOUT: 'storefront_checkout',
  BACKOFFICE: 'backoffice',
  SALESAPP: 'salesapp',
};
